import { Controller } from 'stimulus';

/**
 * @class Jump
 * @extends {Controller}
 */
class MultiSelect extends Controller {
  connect() {
    this.isExpanded = false;
  }

  onToggleClick() {
    this.isExpanded = !this.isExpanded;
    this.toggleA11Y();
  }

  toggleA11Y() {
    this.toggleTarget.setAttribute('aria-expanded', this.isExpanded);
    this.dropdownTarget.setAttribute('aria-expanded', this.isExpanded);
  }

  onOptionChange() {
    const checkedOptions = this.optionTargets.map((option) => {
      if (!option.checked) {
        return null;
      }

      const label = document.querySelector(`[for="${option.id}"]`);

      if (!label) {
        return null;
      }

      return label.textContent.trim();
    })
      .filter((label) => label);

    const defaultText = this.toggleTarget.getAttribute('data-toggle-default');

    this.toggleTarget.textContent = checkedOptions.length
      ? checkedOptions.join(', ')
      : defaultText;
  }

  onWindowKeyUp(event) {
    if (!this.isExpanded) {
      return;
    }

    if (event.key === 'Escape') {
      this.isExpanded = false;
      this.toggleTarget.focus();
      this.toggleA11Y();
    }
  }

  onWindowClick(event) {
    if (!this.isExpanded) {
      return;
    }

    // If click outside of the dropdown...
    if (!event.target.closest(`#${this.element.id}`)) {
      this.isExpanded = false;
      this.toggleA11Y();
    }
  }
}

MultiSelect.targets = [
  'toggle',
  'dropdown',
  'option',
];

export default MultiSelect;
